import styled, { css } from 'styled-components';

export const TranslateText = styled.div`
  ${({ theme }) => css`
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.1px;
    text-decoration-line: underline;
    color: ${window?.settings?.secondary_color ?? '#04333b'};
    user-select: none;
    cursor: pointer;

    &:hover {
      font-weight: 600;
      color: ${theme.colour.primary};
    }
  `}
`;
